import React, { useMemo, useState } from "react";
import { NumberInput, Table, Text } from "@mantine/core";
import { computeLevel } from "../helpers/levelProgress";
import { useFormatter } from "../hooks/useFomatter";

const formatAmount = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "-";
  return amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const LevelTypeTester = ({ form }) => {
  const [formatter] = useFormatter();
  const [amount, setAmount] = useState(25000);
  const pointsPerLevel =
    form?.values?.level?.pointsPerLevel ?? form?.values?.pointsPerLevel;
  const progress = useMemo(
    () => computeLevel({ amount, pointsPerLevel }),
    [amount, pointsPerLevel]
  );

  return (
    <>
      <Text size="sm" color="dimmed" mb="md">
        Enter cumulative points to preview the unbounded Level. Nothing is
        posted.
      </Text>
      <NumberInput
        label="Cumulative Points"
        value={amount}
        precision={2}
        parser={formatter.numberParser}
        formatter={formatter.numberFormat}
        onChange={setAmount}
        mb="md"
      />
      <Table fontSize="sm" withBorder>
        <tbody>
          <tr>
            <td>Points per Level</td>
            <td>{formatAmount(progress.pointsPerLevel)}</td>
          </tr>
          <tr>
            <td>
              <strong>Level</strong>
            </td>
            <td>
              <strong>{progress.level}</strong>
            </td>
          </tr>
          <tr>
            <td>Remainder</td>
            <td>{formatAmount(progress.remainder)}</td>
          </tr>
          <tr>
            <td>Next Level at</td>
            <td>
              {progress.nextLevelAt == null
                ? "-"
                : formatAmount(progress.nextLevelAt)}
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};

export default LevelTypeTester;
